<template>
  <div class="body">
    <div class="container" v-if="img ==='noimal'" @click="playvideo">
      <div class="dot">
        <img :src="noimal" @mouseover="mouseOver">
      </div>
      <div class="pulse"></div>
    </div>
    <div class="container" v-else  @click="playvideo">
      <div class="dot">
        <img :src="hover"  @mouseleave="mouseLeave">
      </div>
      <div class="pulse" style="background:#19FDED;"></div>
    </div>
    <div class="zhezhao" v-if="videoStatus === 1" @click="closevideo">
    </div>
    <div class="video-div" v-if="videoStatus === 1">
      <div class="close" @click="closevideo"><img :src="close"/></div>
      <video    :preload="preload"  :height="height" :width="width" align="center" :controls="controls"  :autoplay="autoplay">
        <source :src="videoSrc" type="video/mp4">
      </video>
    </div>
    <round-images :banner="banner"></round-images>
    <!-- <img
      class="banner"
      :src="banner"
    /> -->
<!-- ************************************************************************************************************************************************************* -->
    <!-- <div class="news-logo-area">
      <div
        class="news-logo"
        v-for="(n, index) in newsLogo"
        :key="index"
        @click="gourl(n.linkUrl)"
      >
        <img :src="n.picUrl" />
      </div>
    </div> -->
    <div class="news-area">
      <div class="title">
        新着情報
      </div>
      <div
        class="news"
        v-for="(n, index) in newss"
        :key="index"
        @click="gonews(n.id)"
      >
        <div class="news-image">
          <img :src="n.newsImage" />
          <img v-if="n.id === 4" :src="normal" class="sonimg" style="width:50px;height:50px;">
        </div>
        <div class="news-inset">
          <div class="news-title" style="font-family:middle;">
            {{ n.title }}
            <div class="news-date" style="font-family:light;">
              {{ n.date }}
            </div>
          </div>
          <div class="news-msg" style="font-family: light;">
            {{ n.msg1 + n.msg2 }}
          </div>
        </div>
      </div>
      <div style="width:100%;text-align: center;">
        <Page :total="news.length" :page-size="pagesize" @on-change="pagenews"/>
        
      </div>
    </div>
  </div>
</template>
<script>
import { banner, newsLogo , normal, noimal, hover, close } from '../../images/news/index'
import roundImages from '../../public-modules/round-images/index'
import news from '../../data-js/news/index'
import Video from 'video.js'
import 'video.js/dist/video-js.css'

export default {
  data () {
    return {
      banner,
      newsLogo,
      normal,
      noimal,
      hover,
      close,
      news,
      newss:[],
      current:1,
      pagesize: 3,
      img:'noimal',
      videoSrc: './static/mp4/pc.mp4',
      playStatus: '',
      muteStatus: '',
      isMute: true,
      isPlay: false,
      width: '820', // 设置视频播放器的显示宽度（以像素为单位）
      height: '460', // 设置视频播放器的显示高度（以像素为单位）
      preload: 'auto', //  建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
      controls: true, // 确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
      autoplay: '',
      videoStatus: 0
      // newsList
    }
  },
  components: {
    roundImages
  },
  methods: {
    pagenews(page){
      this.newss = []
      for(let i =(page*this.pagesize)-2;i<page*this.pagesize;i++){
        if(!this.news[i]){
          return
        }
        this.newss.push(this.news[i])
      }
    },
    gonews(id){
      if(id===4){
        this.playvideo()
      }else{
        this.$router.push('/news?id='+id)
      }
    },
    gourl(url){
      window.location.href = url
    },
    // 移入
    mouseOver() {
      this.img = 'mouse'
    },
    // 移出
    mouseLeave() {
      this.img = 'noimal'
    },
    playvideo() {
      this.videoStatus = 1
    },
    closevideo() {
      this.videoStatus = 0
    }
  },
  mounted(){
    this.newss = []
    for(let i =0;i<this.pagesize;i++){
      if(!this.news[i]){
        return
      }
      this.newss.push(this.news[i])
    }
  }
}
</script>
<style scoped>

@keyframes warn {
  0% {
		transform: scale(0.5);
		opacity: 1;
	}
	100% {
		transform: scale(1);
		opacity: 0.0;
	}
}
/* 保持大小不变的小圆圈  */
.dot {
	position: absolute;
	width: 80px;
	height: 80px;
	left: 21.5px;
	top: 21.5px;
	-webkit-border-radius: 40px;
	-moz-border-radius: 40px;
	border-radius: 40px;
	z-index: 2;
}
.dot img{
  cursor:pointer;
}
/* 产生动画（向外扩散变大）的圆圈  */
.pulse {
	position: absolute;
	width: 130px; 
	height: 130px;
	-webkit-border-radius: 65px;
	-moz-border-radius: 65px;
	border-radius: 65px;
  background: #fff;
	z-index: 1;
	opacity: 0;
	-webkit-animation: warn 2s ease-out;
	-moz-animation: warn 2s ease-out;
	animation: warn 2s ease-out;
	-webkit-animation-iteration-count: infinite;
	-moz-animation-iteration-count: infinite;
	animation-iteration-count: infinite;
}
.container{
  position:absolute;
  left: 223px;
  top: 108px;
  z-index: 2;
  width: 130px;
  height: 130px;
}
.zhezhao{
  width: 100%;
  height: 100%;
  top: 0;
  position:fixed;
  z-index: 9998;
  background: #000000;
  opacity:0.65;
}
.video-div{
  position:fixed;
  bottom:300px;
  left: 25%;
  z-index: 9999;
}
.close img{
  float: right;
  width: 35px;
  padding-right: 0px;
}
.banner {
  display: block;
  width: 100%;
  height: auto;
  min-width: 1100px;
}
.news-logo-area {
  width: 1100px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0 20px;
  margin-top: 50px;
}
.news-logo {
  display: inline-block;
  width: 150px;
  margin: 10px 13.3px;
  cursor: pointer;
  transition: all 0.5s;
}
.news-logo:hover {
  box-shadow: 0px 0px 10px #999;
}
.news-logo img {
  display: block;
  width: 100%;
}
.news-area {
  width: 1100px;
  margin: 0 auto;
  margin-top: 50px;
  box-sizing: border-box;
  padding: 0 20px;
  margin-bottom: 20px;
}
.title {
  font-weight: bold;
  font-size: 20px;
}
.news {
  display: flex;
  border-bottom: solid 1px #999;
  padding: 10px;
  width: 1100px;
  box-sizing: border-box;
  cursor: pointer;
  margin-bottom: 10px;
}
.news-image {
  width: 400px;
  box-sizing: border-box;
  /* padding: 20px; */
  flex: 1;
  position:relative;
}
.sonimg{
  position:absolute;
  top:30%;
  left:41%;
  z-index:2;
}
.news-image img {
  width: 100%;
  display: block;
}
.news-inset {
  flex: 3;
  box-sizing: border-box;
  padding: 20px;
}
.news-title {
  font-weight: bold;
  font-size: 20px;
  position: relative;
  margin-bottom: 15px;
  line-height: 30px;
}
.news-date {
  position: absolute;
  width: 100px;
  height: 23px;
  border: 1px solid #282828;
  border-radius: 4px;
  right: 0;
  bottom: 4px;
  font-size: 12px;
  font-weight: normal;
  text-align: center;
  line-height: 23px;
}
.news-msg {
  font-size: 16px;
}
.news-area .news:nth-last-child(1) {
  border-bottom: none;
}
</style>


// WEBPACK FOOTER //
// src/components/home/index.vue